import {AppDownload} from '@sdox/ui'

import type {XcNwBlock_BlockAppDownloadType_Fragment} from '@sdox/api'

export const BlockAppDownload = ({
  iosHref,
  androidHref,
}: XcNwBlock_BlockAppDownloadType_Fragment) => (
  <AppDownload
    appstoreUrl={iosHref}
    playstoreUrl={androidHref}
  />
)
